import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { requestSocialLink } from 'redux/links/actions';

import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Form } from 'semantic-ui-react';
import TextField from 'components/redux-form-adapters/TextField';
import Button from 'components/elements/buttons/Button';
import CommonErrorIcon from 'components/common/CommonErrorIcon';

import './SocialNetworkRequestForm.css';

const SocialNetworkRequestForm = ({
  handleSubmit,
  reset,
  valid,
  url,
  createSocialLinkRequestStatusError,
  requestSocialLink,
  type,
}) => {

  const handleBlur = useCallback((e) => {
    if (e && e.target && !e.target.value) {
      reset();
    }
  }, []);

  const _handleSubmit = values => {
    requestSocialLink(values.url);
  };

  const handleError = error => {
    let errors;
    if (error) {
      errors = Object.keys(error).map(i => createSocialLinkRequestStatusError[i]);
    }
    return errors;
  };

  const { t } = useTranslation();

  return (
    <>
      <div className="social-network-request-form__component">
        <h4>{t("Can't find the required")} {type}? </h4>
        <p>
          {t("Send us a request below and we will do our best to add it.")}
        </p>

        <div className="social-network-request-form-container">
          <Form
            onSubmit={handleSubmit(_handleSubmit)}
            error={!valid}
          >
            <div className="social-network-request-form-wrapper">

                <div className="social-network-request-form-content">
                  {/* Url */}
                  <div className="field-wrapper">
                    <Field
                      component={TextField}
                      name="url"
                      type="text"
                      placeholder={type}
                      required
                      onBlur={handleBlur}
                    />

                    {createSocialLinkRequestStatusError &&
                      <CommonErrorIcon
                        key="social-network-request-form"
                        errorId="social-network-request-form-error"
                        errorText={handleError(createSocialLinkRequestStatusError)}
                      />
                    }
                  </div>

                    <Button
                      submit
                      disabled={!valid || !url}
                    >
                      {t("Send Request")}
                    </Button>
                </div>

            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

SocialNetworkRequestForm.propTypes = {
  handleSubmit: PropTypes.func,
  reset: PropTypes.func,
  valid: PropTypes.bool,
  url: PropTypes.string,
  createSocialLinkRequestStatusError: PropTypes.object,
  requestSocialLink: PropTypes.func,
  type: PropTypes.string.isRequired,
};

SocialNetworkRequestForm.defaultProps = {
  handleSubmit: null,
  reset: null,
  valid: false,
  url: null,
  createSocialLinkRequestStatusError: null,
  requestSocialLink: null,
};

const mapStateToProps = (state) => {
  const selector = formValueSelector('SocialNetworkRequestForm');
  return {
    url: selector(state, 'url'),
    createSocialLinkRequestStatusError: state.linksReducer.createSocialLinkRequestStatusError,
  };
};

export default connect(
  mapStateToProps,
  {
    requestSocialLink,
  },
)(reduxForm({
  form: 'SocialNetworkRequestForm',
  // validate,
})(SocialNetworkRequestForm));
